import React, {useContext} from 'react';
import { NumericFormat } from 'react-number-format';
import {AppContext} from '../../contexts/AppContext';

const FormattedPrice = ({value, decimals = 2}) => {

    const {locale} = useContext(AppContext);

    let thousandSeparator = '.';
    let decimalSeparator = ',';
    if (locale === 'en') {
        thousandSeparator = ',';
        decimalSeparator = '.';
    }

    return (
        <NumericFormat
            value={value}
            displayType={'text'}
            thousandSeparator={thousandSeparator}
            decimalSeparator={decimalSeparator}
            decimalScale={decimals}
            fixedDecimalScale={true}
            prefix={'€ '}
            renderText={value => value}
        />
    );
};

export default FormattedPrice;
